import React, { useState } from "react";
import CardPage from "../../../../layout/CardPage";
import { CargarDocumentos } from "./_CargaDocumentos";
import { MostrarListaDocumentos } from "./_MostrarListaDocumentos";

export const CargaPagoMasivo = () => {
  const [listaDocumentos, setListaDocumentos] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <CardPage titulo="Cargar Pago Masivo">
      <CargarDocumentos
        setListaDocumentos={setListaDocumentos}
        setLoading={setLoading}
      />
      <MostrarListaDocumentos
        listaDacumentos={listaDocumentos}
        loading={loading}
        setListaDocumentos={setListaDocumentos}
      />
    </CardPage>
  );
};
